var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Button, InputText, InputTextBox, InputDate, Alert } from 'template/lib';
import { useEffect, useState } from 'react';
Modal.setAppElement('#root');
var ModalEditInteration = function (_a) {
    var handleOpenModalEdit = _a.handleOpenModalEdit, handleCloseModalEdit = _a.handleCloseModalEdit, idItem = _a.idItem, usersItem = _a.usersItem, mensage = _a.mensage, details = _a.details;
    var login = useAuth().login;
    var config = { headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) } };
    var _b = useState([]), users = _b[0], setUsers = _b[1];
    var _c = useState([]), selectedUsers = _c[0], setSelectedUsers = _c[1];
    var _d = useState(undefined), description = _d[0], setDescription = _d[1];
    var _e = useState(undefined), hour = _e[0], setHour = _e[1];
    var _f = useState(''), finishDate = _f[0], setFinishDate = _f[1];
    var _g = useState(false), alertOpen = _g[0], setAlertOpen = _g[1];
    var _h = useState(''), message = _h[0], setMessage = _h[1];
    var formatDateToInput = function (dateStr) {
        if (!dateStr)
            return '';
        var _a = dateStr.split('/'), day = _a[0], month = _a[1], year = _a[2];
        return year + "-" + month + "-" + day;
    };
    /* ==========================
       🔧 FORMik
    ========================== */
    var formik = useFormik({
        initialValues: {
            hour: undefined,
            date: undefined,
            description: undefined,
        },
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!finishDate && !values.date) {
                            setMessage('Ops! Parece que você esqueceu de preencher o campo “Data Realizada”.');
                            setAlertOpen(true);
                            return [2 /*return*/];
                        }
                        if ((values.description === undefined || values.description === '') && !description) {
                            setMessage('Ops! Parece que você esqueceu de preencher o campo “Descrição”.');
                            setAlertOpen(true);
                            return [2 /*return*/];
                        }
                        if (!selectedUsers || selectedUsers.length === 0) {
                            setMessage('⚠️ Nenhum usuário selecionado!');
                            setAlertOpen(true);
                            return [2 /*return*/];
                        }
                        setAlertOpen(false);
                        payload = [{
                                Id: idItem,
                                WorkedHours: parseFloat(values.hour !== undefined ? String(values.hour) : String(hour !== null && hour !== void 0 ? hour : 0)),
                                FinishDate: values.date !== undefined ? values.date : finishDate,
                                WorkComments: values.description !== undefined ? values.description : description,
                                Users: selectedUsers.map(function (u) { return u.id; })
                            }];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.post("/signature/edit", payload, config)];
                    case 2:
                        response = _b.sent();
                        mensage(response);
                        handleCloseModal(); // 🔧 FECHA E LIMPA
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        setMessage('Erro ao salvar, existem campos preenchidos incorretamente.');
                        setAlertOpen(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }
    });
    /* ==========================
       🔧 CARREGA DADOS DO ITEM
    ========================== */
    useEffect(function () {
        if (!details)
            return;
        var finishDateItem = formatDateToInput((details === null || details === void 0 ? void 0 : details.finishDateFormatted) || '');
        setFinishDate(finishDateItem);
        setDescription(details === null || details === void 0 ? void 0 : details.workComments);
        setHour(details === null || details === void 0 ? void 0 : details.workedHours);
        setSelectedUsers(usersItem || []);
        // 🔧 SINCRONIZA FORMik
        formik.setValues({
            hour: details === null || details === void 0 ? void 0 : details.workedHours,
            date: finishDateItem,
            description: details === null || details === void 0 ? void 0 : details.workComments
        });
    }, [details, usersItem]);
    /* ==========================
       🔧 BUSCA USUÁRIOS
    ========================== */
    useEffect(function () {
        if (idItem !== undefined) {
            api.get("/signature/user/" + idItem, config)
                .then(function (res) { return setUsers(res.data.users || []); })
                .catch(console.error);
        }
    }, [idItem]);
    /* ==========================
       🔧 LIMPAR AO FECHAR MODAL
    ========================== */
    var handleCloseModal = function () {
        formik.resetForm();
        setDescription(undefined);
        setHour(undefined);
        setFinishDate('');
        setSelectedUsers([]);
        setAlertOpen(false);
        handleCloseModalEdit();
    };
    /* ==========================
       USUÁRIOS
    ========================== */
    var handleSelectUser = function (e) {
        var userId = e.target.value;
        var selected = users.find(function (u) { return u.id === userId; });
        if (selected && !selectedUsers.some(function (u) { return u.id === userId; })) {
            setSelectedUsers(function (prev) { return __spreadArray(__spreadArray([], prev), [selected]); });
        }
    };
    var removeUser = function (userId) {
        setSelectedUsers(function (prev) { return prev.filter(function (u) { return u.id !== userId; }); });
    };
    useEffect(function () {
        if (!alertOpen)
            return;
        var timer = setTimeout(function () { return setAlertOpen(false); }, 15000);
        return function () { return clearTimeout(timer); };
    }, [alertOpen]);
    /* ==========================
       RENDER
    ========================== */
    return (_jsxs(Modal, __assign({ isOpen: handleOpenModalEdit, shouldCloseOnOverlayClick: false, onRequestClose: handleCloseModal, overlayClassName: "react-modal-overly", className: "react-modal-content", contentLabel: "Editar Itera\u00E7\u00E3o" }, { children: [alertOpen && (_jsx("div", __assign({ style: { position: 'fixed', top: '80px', right: 0 } }, { children: _jsx(Alert, __assign({ info: false }, { children: message }), void 0) }), void 0)), _jsxs("div", { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: "font-semibold border-b-2 text-lg" }, { children: "Intera\u00E7\u00E3o" }), void 0), _jsx(AiOutlineClose, { title: "Fechar", className: "cursor-pointer text-sm", onClick: handleCloseModal }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: "mx-4 my-4" }, { children: [_jsx("div", __assign({ className: "grid justify-items-start" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-3 justify-items-end" }, { children: [_jsx(InputDate, { name: "date", label: "Data Realizada", value: formik.values.date || '', onChange: function (e) {
                                                    formik.setFieldValue('date', e.target.value);
                                                }, style: { width: '10rem' } }, void 0), _jsx(InputText, { onChange: formik.handleChange, name: "hour", label: "Horas Realizadas", inicialValue: formik.values.hour !== undefined ? formik.values.hour : hour, maxLength: 5, width: "10rem" }, void 0), _jsxs("div", __assign({ style: { marginTop: '5px', width: '100%' } }, { children: [_jsx("label", __assign({ style: {
                                                            fontWeight: 600,
                                                            color: '#4B5563',
                                                            padding: '0.20rem 48px 0.20rem 0',
                                                            marginRight: '0.25rem',
                                                            fontSize: '0.85rem',
                                                            lineHeight: '1rem'
                                                        } }, { children: "Usu\u00E1rios:" }), void 0), _jsxs("select", __assign({ onChange: handleSelectUser, defaultValue: "", style: {
                                                            padding: '3px',
                                                            borderRadius: '4px',
                                                            border: '0.05rem solid #D1D5DB',
                                                            fontFamily: 'inherit',
                                                            outline: 'none',
                                                            width: '155px'
                                                        } }, { children: [_jsx("option", __assign({ value: "", disabled: true }, { children: "Selecione um usu\u00E1rio" }), void 0), users.map(function (u) { return (_jsx("option", __assign({ value: u.id }, { children: u.name }), u.id)); })] }), void 0), _jsx("div", __assign({ style: { marginTop: '10px' } }, { children: selectedUsers.map(function (u) { return (_jsxs("span", __assign({ onClick: function () { return removeUser(u.id); }, style: {
                                                                display: 'inline-block',
                                                                padding: '5px 10px',
                                                                margin: '5px',
                                                                backgroundColor: '#e0e0e0',
                                                                borderRadius: '15px',
                                                                cursor: 'pointer'
                                                            } }, { children: [u.name, " \u00D7"] }), u.id)); }) }), void 0)] }), void 0), _jsx(InputTextBox, { onChange: formik.handleChange, inicialValue: formik.values.description !== undefined ? formik.values.description : description, minLength: "20", width: "100%", height: "18rem", name: "description", label: "Descri\u00E7\u00E3o" }, void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "mt-4 flex justify-end" }, { children: _jsx(Button, __assign({ type: "submit", isButtonDisabled: details === null || details === void 0 ? void 0 : details.disabled }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0)] }), void 0));
};
export default ModalEditInteration;
